import { useMemo } from "react";
import Grid from "components/primitives/Grid";
import { useAthlete } from "hooks";
import AthleteName from "components/AthleteName";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import moment from "moment";

type TooltipCardHeaderProps =
  | {
      athleteId: string;
      category?: undefined;
      color: string;
      completedDate: string;
      name?: undefined;
    }
  | {
      athleteId?: undefined;
      category: string;
      color?: undefined;
      completedDate: string;
      name: string;
    };

function TooltipCardHeader(props: TooltipCardHeaderProps) {
  const { athleteId } = props;
  const athlete = useAthlete(props.athleteId);

  const gridTitleComponent = useMemo(() => {
    if (athleteId) {
      return (
        <Grid size="grow">
          <AthleteName athlete={athlete} avatarColor={props.color} />
        </Grid>
      );
    }
    return (
      <Grid size="grow">
        <Typography noWrap title={props?.category}>
          <Box component="span" sx={{ color: "grey.800", fontWeight: "fontWeightNormal", fontSize: 12 }}>
            {props?.category}
          </Box>
        </Typography>
        <Typography variant="h4" noWrap title={props.name}>
          {props.name}
        </Typography>
      </Grid>
    );
  }, [athlete, athleteId, props.category, props.color, props.name]);

  return (
    <Grid container spacing={0} alignItems="center">
      {gridTitleComponent}
      {props.completedDate && (
        <Grid>
          <Typography gutterBottom={false}>{moment(props.completedDate).format("DD MMM YYYY")}</Typography>
        </Grid>
      )}
    </Grid>
  );
}

export default TooltipCardHeader;
